import { render, staticRenderFns } from "./OrgNews.vue?vue&type=template&id=30ee4e50&"
import script from "./OrgNews.vue?vue&type=script&lang=js&"
export * from "./OrgNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports